export default __webpack_public_path__ + "static/media/perfit-logo-black.da2634f3.svg";